'use client';
import { Button } from '@dolcevia/ui/components/ui/button';
import { Accordion } from '@szhsin/react-accordion';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { FaqContent } from './faq-content';
import type { FaqProps } from './faq-types';

export const Faq = ({
  hideContactButton,
  questions: questionTab,
  title,
  translationKey = 'Faq',
}: FaqProps) => {
  const t = useTranslations(translationKey);
  return (
    <div className="flex flex-col gap-8">
      {title}
      <Accordion
        className="w-full flex flex-col gap-4"
        transition
        transitionTimeout={250}
      >
        {questionTab.map((question, index) => (
          <FaqContent
            translationKey={translationKey}
            index={index}
            question={question.question}
            answer={question.answer}
            key={question.question}
          />
        ))}
      </Accordion>
      {!hideContactButton && (
        <div className="flex flex-col text-center items-center gap-4">
          <p className="font-medium">
            {t("On a pas répondu à l'une de vos questions ?")}
          </p>
          <Link href="/contact">
            <Button className="w-max flex">{t('Nous contacter')}</Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Faq;
